import * as React from 'react';

import { MAX_QUIZ_NAME_LENGTH } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';
import { useDispatch, useSelector } from 'react-redux';

import EditableTitle from '~shared/components/EditableTitle/EditableTitle';
import { Quiz } from '~teacher/models/quizzes';
import { selectEditingQuiz } from '~teacher/slices/quiz/quizSelectors';
import { updateQuizTitle } from '~teacher/slices/quiz/quizSlice';

import { AppDispatch } from '../../../../store';

export function QuizEditorEditableQuizTitle({
  isControlsDisabled,
}: {
  isControlsDisabled: boolean;
}) {
  const dispatch: AppDispatch = useDispatch();

  const handleEditQuizTitle = React.useCallback(
    (textFieldContent: string) =>
      dispatch(updateQuizTitle({ name: textFieldContent })),
    [dispatch]
  );

  const quiz = useSelector(selectEditingQuiz) as Quiz & { isDirty: boolean };
  const { name: quizTitle, lastUpdated } = quiz;

  const isFreshQuiz = lastUpdated === null;

  return (
    <EditableTitle
      isDisabled={isControlsDisabled}
      onChange={handleEditQuizTitle}
      a11yLabel={translate('Quiz Title')}
      text={quizTitle}
      placeholderText={translate('Quiz Title')}
      maxLength={MAX_QUIZ_NAME_LENGTH}
      autoSelect={isFreshQuiz}
    />
  );
}
